export const MODULES_BASENAME = '';

export enum ModuleRoute {
  Login = '/login',
  Dashboard = '/dashboard',
  Configuration = '/config',
  Inventory = '/inventory',
  Sale = '/sale',
  CashFlow = '/cash-flow',
  Report = '/report',
  ElectronicBilling = '/electronic-billing',
}
